import React from 'react';
import {
  Card,
  CardContent,
  CardMedia,
  Typography,
  Box,
  Chip,
} from '@mui/material';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import LocationOnIcon from '@mui/icons-material/LocationOn';

const LabCard = ({ labData, themeColors }) => {
  return (
    <Card sx={{ boxShadow: 3, borderRadius: '12px', marginBottom: '20px' }}>
      <CardMedia
        component="img"
        height="100"
        image={
          labData.image?.code === 'LAB_DETAIL_PLACEHOLDER'
            ? '/placeholder-lab.jpg'
            : labData.image.code
        }
        alt={labData.name}
      />
      <CardContent>
        <Typography variant="h5" fontWeight="bold" gutterBottom>
          {labData.name}
        </Typography>
        <Typography variant="body2" color={themeColors.text} paragraph>
          {labData.description}
        </Typography>
        <Box display="flex" alignItems="center" gap={1} mb={2}>
          <AccessTimeIcon color="primary" />
          <Typography variant="body2">
            {labData.open_time} - {labData.close_time}
          </Typography>
        </Box>
        <Box display="flex" alignItems="center" gap={1} mb={2}>
          <LocationOnIcon color="secondary" />
          <Typography variant="body2">{labData.address}</Typography>
        </Box>
        <Box display="flex" gap={2}>
          <Chip
            label={`Distance: ${labData.distance.value} ${labData.distance.unit}`}
          />
          <Chip label={`${labData.total_tests}`} />
        </Box>
      </CardContent>
    </Card>
  );
};

export default LabCard;